<template>
  <tr>
    <td>{{ index + 1 }}</td>
    <td>{{ item.category }}</td>
    <td>{{ item.parent.title }}</td>
    <td>{{ item.title }}</td>
    <td style="width: 7vw;">
      <input v-model.number="power" type="text" class="form-control" @input="updateItem" />
    </td>
    <td style="width: 7vw;">
      <input v-model.number="interest" type="text" class="form-control" @input="updateItem" />
    </td>

  </tr>
</template>

<script>
export default {
  name: "BeneficiaryRow",
  props: {
    item: Object,
    index: Number,
  },
  data() {
    return {
      power: this.item.power_beneficiary ? this.item.power_beneficiary.power : 0,  // Default value; replace with actual data as needed
      interest: this.item.power_beneficiary ? this.item.power_beneficiary.interest : 0,  // Default value; replace with actual data as needed
    };
  },
  computed: {
    average() {
      let result = this.power * this.interest;
      return parseFloat(result.toFixed(2));
    }
  },
  methods: {
    updateItem() {
      this.$emit('update', {
        id: this.item.id,
        power: this.power,
        interest: this.interest,
        average: this.average,
      });
    },
  },
  mounted() {
    this.updateItem();
  },
};
</script>
